export default "__VITE_ASSET__37d87405__"